export default __webpack_public_path__ + "static/media/treasure10.a7209a83.png";